import BaseAPI from './BaseAPI';


export class AssistanceRequestAPI extends BaseAPI {

	async loadData(assistanceRequestId) {
		return this.request(`/-/assistanceRequest/${assistanceRequestId}`, 'GET');
	}
	async close(id, notes) {
		return this.request(`/-/assistanceRequest/close`, 'DELETE', {id, notes});
	}
	async start(config, pageId) {
		return this.request(`/-/assistanceRequest/start`, 'POST', {config, pageId});
	}
}
